<template>
  <q-expansion-item
      :class="showAll?'fixed-header-position':'q-ma-xs'"
      :label="showAll && items?'':`${title} (${items.length})`"
      header-class="bg-brown-10 text-white"
      expand-icon-class="text-white"
      :default-opened="showAll">
    <q-card flat>
      <q-card-section class="no-padding fixed-header-position bg-white">
        <q-banner class="bg-blue text-white" v-if="showAll">
          {{ `${title} (${items.length})` }}
        </q-banner>
        <q-input type="search" v-model="filter" filled label="جستجو..." v-if="showAll"/>
      </q-card-section>
      <q-card-section v-if="showAll">
        <q-chip square label="جمع کرایه راننده" color="indigo" text-color="white">
          <q-badge class="q-ml-xs" color="red" text-color="white"
                   :label="lodash.sumBy(items, 'TransferCost').toLocaleString()"/>
        </q-chip>

        <q-chip square label="جمع کرایه زیرفاکتور" color="indigo" text-color="white">
          <q-badge class="q-ml-xs" color="red" text-color="white"
                   :label="lodash.sumBy(items, 'Transpose_Cost').toLocaleString()"/>
        </q-chip>
      </q-card-section>
      <q-card-section class="no-padding">
        <q-banner class="bg-blue text-white" inline-actions
                  v-if="$store.state.balanceInfo && $store.state.roles.some(v=>['admin', 'can_see_account_balance'].includes(v))">
          <span>موجودی</span> <span
            class="text-bold">{{ $store.state.balanceInfo.toLocaleString() }}</span>
          <template v-slot:action>
            <q-btn flat icon="request_quote" round
                   @click="sendSMSForPay">
              <q-tooltip>
                ارسال درخواست شارژ کیف پول
              </q-tooltip>
            </q-btn>
            <q-btn icon="payments" flat
                   round
                   v-if="$store.state.roles.some(v=>['admin','can_see_main_account_transactions'].includes(v))"
                   @click="loadTransactionsData">
              <q-tooltip>
                نمایش گردش حساب
              </q-tooltip>
            </q-btn>
          </template>
        </q-banner>
        <q-banner class="bg-blue text-white q-mt-xs" inline-actions>
          <span>مبلغ کل کرایه ها</span> <span
            class="text-bold">{{ lodash.sumBy(items, item => item.TransferCost).toLocaleString() }}</span>
          <template v-slot:action>
            <q-btn icon="info" flat round padding="none">
              <q-popup-proxy>
                <q-card flat>
                  <q-card-section class="no-padding">
                    <q-banner class="bg-blue text-white" inline-actions>
                      <span>دسته بندی برحسب راننده</span>
                      <template v-slot:action>
                        <q-btn icon="close" flat round v-close-popup/>
                      </template>
                    </q-banner>
                    <q-chip clickable v-if="isFiltered" label="حذف فیلتر" size="xs" icon="close"
                            @click="removeFilterByVisitorName"/>
                  </q-card-section>
                  <q-card-section class="no-padding" v-for="(item, index) in driverGroupedInfo" :key="index">
                    <q-chip clickable @click="filterByVisitorName(item)" square color="indigo" text-color="white"
                            :label="item.Visitor_Name">
                      <q-badge class="q-ml-sm" color="red" text-color="white" :label="item.totalCost.toLocaleString()"/>
                    </q-chip>
                  </q-card-section>
                </q-card>
              </q-popup-proxy>
            </q-btn>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-actions>
        <q-btn v-if="!showAll && $store.state.roles.some(v=>['admin','can_issue_way_bill'].includes(v))" round flat
               icon="add_circle_outline" color="indigo" padding="none"
               @click="showManageWayBillDialog(undefined)">
          <q-tooltip>
            صدور بارنامه
          </q-tooltip>
        </q-btn>
      </q-card-actions>
      <q-card-section class="no-padding">
        <q-table
            :data="items"
            row-key="ID"
            wrap-cells
            :hide-header="$q.screen.lt.md || !showAll"
            :filter="filter"
            flat
            :pagination="pagination">
          <template v-slot:header>
            <q-tr class="text-subtitle2 text-center">
              <td>شماره بارنامه</td>
              <td>راننده</td>
              <td>ثبت کننده</td>
              <td>کرایه راننده</td>
              <td>کرایه زیر فاکتور</td>
              <td>مبلغ کل</td>
              <td>تاریخ ثبت</td>
              <td>تاریخ ارسال بار</td>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props" class="my-class" v-if="$q.screen.lt.md || !showAll">
              <q-tooltip v-if="!showAll" content-class="bg-transparent" anchor="top middle">
                <q-banner rounded dense class="bg-green text-white text-subtitle1">
                  {{ title }}
                </q-banner>
              </q-tooltip>
              <q-td style="max-width: 400px">
                <q-card class="shadow-10">
                  <q-card-section class="no-padding">
                    <q-badge v-if="props.row.DIFF!==0" rounded :label="`${props.row.DIFF} روز پیش`"
                             :color="props.row.DIFF<=30?'green-14':'red-14'" text-color="white"/>
                    <q-badge v-if="props.row.DIFF===0" rounded :label="`امروز`"
                             color="green-14" text-color="white"/>
                    <q-space/>
                    <q-chip dense square icon="pin" color="purple" text-color="white" :label="props.row.WayBillNumber">
                      <q-badge v-if="showAll && props.row.Sale_Nums && props.row.Sale_Nums!==''" color="indigo"
                               class="q-ml-md" text-color="white"
                               :label="props.row.Sale_Nums.length"/>
                    </q-chip>
                    <q-space/>
                    <q-badge :color="props.row.ActualSendDatetime?'green-10':'red-10'" text-color="white"
                             :label="props.row.ActualSendDatetime?'تاییدیه حرکت به مقصد اعلان شده است':'تایید حرکت به مقصد اعلان نشده است'"/>
                    <q-space/>
                    <q-badge v-if="props.row.SaleExiCountNotConfirm>0"
                             color="red-10" text-color="white" class="text-bold"
                             :label="` تعداد (${props.row.SaleExiCountNotConfirm}) فاکتور به مشتری تحویل داده نشده است `"/>
                    <q-space/>
                    <q-badge v-if="!props.row.ShabaVerify"
                             color="red-10" text-color="white" class="text-bold"
                             :label="`شماره شبا تایید نشده است`"/>
                    <q-space/>
                    <q-badge class="q-ml-xs" rounded color="green-10 text-white" v-if="props.row.HasFinanceDocument"
                             label="سند هزینه صادر شده است"/>
                    <q-badge class="q-ml-xs" rounded color="green-10 text-white" v-if="props.row.IsPay"
                             label="پرداخت شده"/>
                    <q-chip size="sm" icon="attach_file" color="blue-grey" flat round
                            clickable
                            label="ضمیمه دارد"
                            text-color="white"
                            @click="downloadAttachment(props.row)"
                            v-if="$store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                                && props.row.HasAttachment">
                      <q-tooltip>
                        دانلود ضمیمه
                      </q-tooltip>
                    </q-chip>
                  </q-card-section>
                  <q-card-section class="no-padding">
                    <q-chip dense square :label="props.row.UserName" icon="support_agent">
                      <q-tooltip>
                        صادر کننده بارنامه
                      </q-tooltip>
                    </q-chip>
                    <q-chip dense square :label="props.row.Visitor_Name" icon="person"/>
                    <q-card-section v-if="props.row.Sale_Nums && props.row.Sale_Nums!==''" class="no-padding">
                      <q-space v-if="props.row.Sale_Nums && props.row.Sale_Nums!=='' &&
                      lodash.uniq(props.row.Sale_Nums.map(item=>item.City_Name)) &&
                      lodash.uniq(props.row.Sale_Nums.map(item=>item.City_Name)).length>1"/>
                      <q-chip dense square
                              v-for="(item, index) in lodash.uniq(props.row.Sale_Nums.map(rec=>rec.City_Name))"
                              :label="item" :key="index" icon="location_city"/>
                    </q-card-section>
                    <q-space/>
                    <q-chip dense square color="brown" text-color="white" icon="calendar_today"
                            :label="props.row.WayBillDateTime">
                      <q-tooltip>
                        تاریخ ثبت
                      </q-tooltip>
                    </q-chip>
                    <q-space v-if="props.row.TransferDateTime && !showAll"/>
                    <q-chip dense v-if="props.row.TransferDateTime" square color="brown" text-color="white"
                            icon="local_shipping"
                            :label="props.row.TransferDateTime">
                      <q-tooltip>
                        تاریخ ارسال بار
                      </q-tooltip>
                    </q-chip>
                  </q-card-section>
                  <q-card-section class="text-center no-padding">
                    <table class="no-padding no-margin">
                      <thead class="text-center text-bold" style="margin: 0;padding: 0">
                      <tr>
                        <td>کرایه راننده</td>
                        <td>کرایه زیرفاکتور</td>
                        <td>
                          مبلغ بار
                        </td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="text-center" style="padding: 0;margin: 0">
                          <q-badge v-if="props.row.TransferCost" class="q-ml-xs" color="green-10" text-color="white"
                                   :label="props.row.TransferCost.toLocaleString()"/>
                        </td>
                        <td class="text-center" style="padding: 0;margin: 0">
                          <q-badge v-if="props.row.Transpose_Cost" class="q-ml-xs" color="green-10" text-color="white"
                                   :label="props.row.Transpose_Cost.toLocaleString()"/>
                        </td>
                        <td class="text-center" style="padding: 0;margin: 0">
                          <q-badge class="q-ml-xs" color="green-10" text-color="white"
                                   :label="lodash.sumBy(props.row.Sale_Nums,'Sale_Pay').toLocaleString()"/>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </q-card-section>
                  <q-card-section class="no-padding" v-if="props.row.Sale_Nums===''">
                    {{ props.row.Title }}
                  </q-card-section>
                  <q-card-actions class="no-padding">
                    <q-btn v-if="props.row.Sale_Nums && props.row.Sale_Nums!==''" icon="visibility" color="indigo" flat
                           round
                           @click="showDetailDialogs(props.row)">
                      <q-tooltip>
                        مشاهده اقلام بارنامه
                      </q-tooltip>
                    </q-btn>
<!--                    (((props.row.HasFinanceDocument && props.row.IsPay) || props.row.Visitor_ID===22-->
<!--                    || props.row.Visitor_ID===25 || props.row.Visitor_ID===24 || props.row.Visitor_ID===40))-->
<!--                    || props.row.Visitor_ID===30 || !props.row.TransferCost &&-->
                    <q-btn icon="done_all" color="green" flat round
                           @click="changeWayBillStat(props.row.WayBillNumber)"
                           v-if="!showAll &&
                           $store.state.roles.some(v=>['admin','can_set_way_bill_receive_state'].includes(v))">
                      <q-tooltip>
                        تاییدیه رسید بار
                      </q-tooltip>
                    </q-btn>
                    <q-btn v-if="props.row.Sale_Nums && props.row.Sale_Nums!==''"
                           icon="print" color="indigo" flat round @click="printHava(props.row.WayBillNumber)">
                      <q-tooltip>
                        چاپ
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="attach_file" color="blue-grey" flat round
                           @click="loadUploadDialog(props.row)"
                           v-if="$store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                               && !props.row.HasAttachment">
                      <q-tooltip>
                        ضمیمه نمودن بارنامه
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="attach_money" color="blue-grey" flat round
                           :disable="!props.row.ShabaVerify"
                           @click="addPayFinanceDocument(props.row)"
                           v-if="props.row.TransferCost && $store.state.roles.some(v=>['admin','can_pay_way_bill'].includes(v))
                           && $store.state.financeServiceStatus
                           && $store.state.balanceInfo
                           && (props.row.SaleExiCountNotConfirm === 0 || props.row.Sale_Nums==='')">
                      <q-tooltip>
                        پرداخت مبلغ بارنامه
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="layers_clear" color="red-10" flat round
                           v-if="$store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                               && props.row.HasAttachment"
                           @click="removeAttachment(props.row)">
                      <q-tooltip>
                        حذف ضمیمه
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="delete" color="red-14" flat round @click="removeWayBill(props.row.WayBillNumber)"
                           v-if="$store.state.roles.some(v=>['admin','can_delete_waybill'].includes(v))">
                      <q-tooltip>
                        حذف
                      </q-tooltip>
                    </q-btn>
                  </q-card-actions>
                </q-card>
              </q-td>
            </q-tr>
            <q-tr :props="props" class="my-class" v-if="!$q.screen.lt.md && showAll">
              <q-td>
                <q-card flat>
                  <q-card-section class="no-padding">
                    <q-badge v-if="props.row.DIFF!==0" rounded :label="`${props.row.DIFF} روز پیش`"
                             :color="props.row.DIFF<=30?'green-14':'red-14'" text-color="white"/>
                    <q-badge v-if="props.row.DIFF===0" rounded :label="`امروز`"
                             color="green-14" text-color="white"/>
                  </q-card-section>
                  <q-card-section class="no-padding">
                    <q-chip dense square icon="pin"
                            color="purple" text-color="white" :label="props.row.WayBillNumber">
                      <q-badge v-if="showAll && props.row.Sale_Nums && props.row.Sale_Nums!==''" color="indigo"
                               class="q-ml-md" text-color="white"
                               :label="props.row.Sale_Nums.length"/>
                    </q-chip>
                  </q-card-section>
                  <q-card-section v-if="props.row.Title">
                    {{ props.row.Title }}
                  </q-card-section>
                  <q-card-actions>
                    <q-btn icon="visibility" color="indigo" flat round
                           v-if="props.row.Sale_Nums && props.row.Sale_Nums!==''"
                           @click="showDetailDialogs(props.row)">
                      <q-tooltip>
                        مشاهده اقلام بارنامه
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="done_all" color="green" flat round
                           @click="changeWayBillStat(props.row.WayBillNumber)"
                           v-if="!showAll
                           && $store.state.roles.some(v=>['admin','can_set_way_bill_receive_state'].includes(v)) || props.row.Sale_Nums===''">
                      <q-tooltip>
                        تاییدیه رسید بار
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="print" color="indigo" flat
                           v-if="props.row.Sale_Nums && props.row.Sale_Nums!==''"
                           round @click="printHava(props.row.WayBillNumber)">
                      <q-tooltip>
                        چاپ
                      </q-tooltip>
                    </q-btn>
                    <q-btn icon="attach_file" color="indigo" flat
                           v-if="props.row.Sale_Nums && props.row.Sale_Nums!==''"
                           round @click="downloadAttachment(props.row)">
                      <q-tooltip>
                        چاپ
                      </q-tooltip>
                    </q-btn>
                  </q-card-actions>
                </q-card>
              </q-td>
              <td class="text-center">
                <q-chip dense square :label="props.row.Visitor_Name" icon="person"/>
                <q-space/>
                <div v-if="props.row.Sale_Nums && props.row.Sale_Nums!==''">
                  <q-chip square v-for="(item, index) in lodash.uniq(props.row.Sale_Nums.map(item=>item.City_Name))"
                          :label="item" :key="index" icon="location_city"/>
                </div>
              </td>
              <td class="text-center">
                <q-chip dense square :label="props.row.UserName" icon="support_agent">
                  <q-tooltip>
                    صادر کننده بارنامه
                  </q-tooltip>
                </q-chip>
              </td>
              <td class="text-center">
                <q-chip square color="red" v-if="props.row.TransferCost" text-color="white"
                        :label="props.row.TransferCost.toLocaleString()"/>
              </td>
              <td class="text-center">
                <q-chip square color="red" v-if="props.row.Transpose_Cost" text-color="white"
                        :label="props.row.Transpose_Cost.toLocaleString()"/>
              </td>
              <td class="text-center">
                <q-chip v-if="lodash.sumBy(props.row.Sale_Nums,'Sale_Pay')" color="green" text-color="white" square
                        icon="attach_money"
                        :label="lodash.sumBy(props.row.Sale_Nums,'Sale_Pay').toLocaleString()"/>
              </td>
              <td class="text-center">
                <q-chip dense square color="red" text-color="white" icon="calendar_today"
                        :label="props.row.WayBillDateTime">
                  <q-tooltip>
                    تاریخ ثبت
                  </q-tooltip>
                </q-chip>
              </td>
              <td class="text-center">
                <q-chip dense v-if="props.row.TransferDateTime" square color="deep-orange" text-color="white"
                        icon="local_shipping"
                        :label="props.row.TransferDateTime">
                  <q-tooltip>
                    تاریخ ارسال بار
                  </q-tooltip>
                </q-chip>
              </td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
    <q-dialog persistent maximized v-model="manageWayBillDialog">
      <IssueWayBill @close-dialog="closeDialog" :title="manageWayBillDialogTitle" :available-items="availableItems"/>
    </q-dialog>

    <q-dialog v-model="customerInfoDialog" :maximized="$q.screen.lt.md">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>

    <q-dialog v-model="showDetailsDialog" :maximized="$q.screen.lt.md">
      <WayBillItems :way-bill-number="selectedWayBill" :details-items="detailsItems"/>
    </q-dialog>

    <q-dialog v-model="uploadDocumentDialog">
      <WayBillAttachment v-if="selectedWayBill"
                         :filename="selectedFileName"
                         @uploaded_finished="uploadedFinish"
                         :file-kind="1"/>
    </q-dialog>
    <q-dialog v-model="payManagementDialog" persistent>
      <WayBillPayment :way-bill-info="selectedWayBill"
                      @issue-finance-document="issueFinanceDocument"
                      @pay-finance-document="payDocument"/>
    </q-dialog>
    <q-dialog v-model="transactionsListDialog" maximized>
      <Transactions :is-dialog="true" selected-account-number="0303647823007"/>
    </q-dialog>
  </q-expansion-item>
</template>

<script>
import IssueWayBill from "@/components/WayBill/IssueWayBill";
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";
import WayBillItems from "@/components/OrderTrace/WayBillItems";
import WayBillAttachment from "@/components/WayBill/WayBillAttachment.vue";
import WayBillPayment from "@/components/WayBill/WayBillPayment.vue";
import Transactions from "@/components/Finnotech/Transactions.vue";

export default {
  name: "WayBillList",
  components: {Transactions, WayBillPayment, WayBillAttachment, WayBillItems, CustomerInfo, IssueWayBill},
  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    availableItems: {
      type: Array,
      default: () => [],
      required: true
    },
    showAll: {
      type: Boolean
    },
    driverGroupedInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      transactionsListDialog: false,
      isFiltered: false,
      optionsCitiesList: [],
      citiesList: [],
      citiesSelected: undefined,
      filter: '',
      selectedVisitorID: undefined,
      selectedWayBill: null,
      selectedFileName: undefined,
      showDetailsDialog: false,
      customerInfoDialog: false,
      selectedCustomer: '',
      selectedHavaNum: '',
      showHavaDetailsDialog: false,
      manageWayBillDialogTitle: '',
      manageWayBillDialog: false,
      pagination: {
        rowsPerPage: 5
      },
      detailsItems: [],
      uploadDocumentDialog: false,
      payManagementDialog: false,
    }
  },
  methods: {
    ...mapActions({
      setWayBillList: 'Orders/getWayBillList',
      deleteWayBill: 'Orders/deleteWayBillList',
      setCustomerInfo: 'Customers/get_customer_info',
      setWayBillState: 'Orders/setWayBillState',
      downloadFile: 'Orders/downloadFile',
      setAttachmentFlag: 'Drivers/setWayBillAttachmentFlag',
      SendSMS: 'Finnotech/sendFinnotechSms',
    }),
    loadTransactionsData() {
      this.transactionsListDialog = true
    },
    filterByVisitorName(item) {
      this.selectedVisitorID = item.Visitor_ID
      this.isFiltered = true
      this.$emit('filtered', this.selectedVisitorID)
    },
    removeFilterByVisitorName() {
      this.isFiltered = false
      this.selectedVisitorID = undefined
      this.$emit('filtered', this.selectedVisitorID)
    },
    issueFinanceDocument(args) {
      this.$emit('issue-finance-document', args)
    },
    payDocument(args) {
      this.$emit('pay-finance-document', args)
    },
    sendSMSForPay() {
      this.SendSMS({
        phoneNo: '09120720616',
        message: `مبلغ کرایه رانندگان هم اکنون ${this.lodash.sumBy(this.items, 'TransferCost').toLocaleString()} می باشد که از میزان موجودی کیف پول بیشتر است.`
      }).then(() => {
        this.$q.notify({
          type: 'positive',
          color: 'positive',
          message: 'پیامک ارسال گردید',
          position: 'top'
        })
        this.messageBody = ''
        this.$emit('sms_sended')
      }).catch(() => {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          message: 'پیامک ارسال نگردید',
          position: 'top'
        })
      })
    },
    addPayFinanceDocument(rowInfo) {
      this.selectedWayBill = rowInfo
      this.payManagementDialog = true
    },
    uploadedFinish(args) {
      this.uploadDocumentDialog = false
      const foundedIndex = this.items.findIndex(x => x.WayBillNumber === parseInt(args.filename))
      this.items[foundedIndex].HasAttachment = true
    },
    removeAttachment(args) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'ضمیمه حذف شود؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.setAttachmentFlag({wayBillNumber: args.WayBillNumber, flag: 0}).then(() => {
          const foundedIndex = this.items.findIndex(x => x.WayBillNumber === parseInt(args.WayBillNumber))
          this.items[foundedIndex].HasAttachment = false
        })
      })
    },
    loadUploadDialog(rowInfo) {
      this.selectedWayBill = rowInfo
      this.selectedFileName = rowInfo.WayBillNumber.toString()
      this.uploadDocumentDialog = true
    },
    downloadAttachment(args) {
      this.downloadFile(
          {
            filePath: `WayBill/${args.WayBillNumber}_1.pdf`,
            fileExtension: 'pdf',
            mimeType: 'application/pdf'
          }).then(async (res) => {
        await this.openURL(res.data.publicLink)
      })
    },
    showDetailDialogs(rows) {
      this.selectedWayBill = rows.WayBillNumber;
      this.detailsItems = rows.Sale_Nums;
      this.showDetailsDialog = true;
    },
    changeWayBillStat(billNumber) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'رسید تحویل بار به ثبت برسد؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.setWayBillState(billNumber).then(() => {
          this.$emit('refresh-data', billNumber)
        })
      })

    },
    getCustomerInfo(id) {
      this.setCustomerInfo(id).then((res) => {
        this.selectedCustomer = res.data[0]
        this.customerInfoDialog = true
      })
    },
    async printHava(wayBillNumber) {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/فاکتورهای فروش/بارنامه?rs:Format=PDF&WayBillNumber=${wayBillNumber}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    closeDialog() {
      this.manageWayBillDialog = false
      this.$emit('refresh-data');
    },
    showManageWayBillDialog: function (row) {
      if (row === undefined) {
        this.manageWayBillDialogTitle = "صدور بارنامه جدید"
      } else {
        this.manageWayBillDialogTitle = "ویرایش بارنامه"
      }
      this.manageWayBillDialog = true;
    },
    removeWayBill(num) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'بارنامه حذف گردد؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.deleteWayBill(num).then(() => {
          this.$emit('refresh-data', num);
        })
      }).onCancel(() => {
      })
    }
  },
  created() {
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}

.fixed-header-position {
  position: sticky;
  top: 50px;
  z-index: 1000;
}
</style>